import { Helpers } from '../../helpers';
import { IRigRateType } from '../../interfaces/irig-rate-type';
import { RigContractStatus } from '../rig-contract-status';
import { RigHistory } from '../rig-history';
import { RigRate } from '../rig-rate';

export class RigRateTypeBase {
  RigRateTypeId: number;
  Description: string;
  Rate: number;
  RigContractStatusId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  RigHistory_RigRateType?: Array<RigHistory> | null;
  RigRates_RigRateType?: Array<RigRate> | null;
  RigContractStatus?: RigContractStatus;

  constructor(item?: IRigRateType) {
    if (item) {

      this.RigRateTypeId = item.RigRateTypeId;
      this.Description = item.Description;
      this.Rate = item.Rate;
      this.RigContractStatusId = item.RigContractStatusId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.RigHistory_RigRateType = Helpers.createClassArray(RigHistory, item.RigHistory_RigRateType);
      this.RigRates_RigRateType = Helpers.createClassArray(RigRate, item.RigRates_RigRateType);
      this.RigContractStatus = new RigContractStatus(item.RigContractStatus);
    }
  }
}